<div>
  <p>{{ 'EXCEPTIONAL_OPENING_HOURS_EXPLANATION_PART_1' | translate }}</p>
  <p>{{ 'EXCEPTIONAL_OPENING_HOURS_EXPLANATION_PART_2' | translate }}</p>
</div>

<div class="row">
  <div class="col-12">
    {{ 'ADD_EXCEPTION' | translate }}
    <kendo-datepicker
      [min]="minExceptionDate"
      [(ngModel)]="exceptionDate"
      (valueChange)="addException()"
    ></kendo-datepicker>
  </div>

  <div class="col-12">
    <lh-opening-hours-picker
      *ngFor="let e of openingHours.exceptions"
      showRemove="true"
      (remove)="removeException(e)"
      [(openingHours)]="e.openingHours"
      [heading]="e.date | lhMoment: 'localeDateShort'"
      [description]="e.description"
      (openingHoursChange)="onChange($event)"
    >
    </lh-opening-hours-picker>
  </div>
</div>
